<!--ImageItem.vue-->
<template>
  <figure v-lazyload class="image__wrapper">
    <div class="image__spinner active"></div>
    <img
      class="image__item"
      :data-url="source"
      :alt="alt"
    >
  </figure>
</template>

<script>
import LazyLoadDirective from '@/directives/LazyLoadDirective'

export default {
  props: {
    source: String,
    alt: String
  },
  directives: {
    lazyload: LazyLoadDirective
  }
}
</script>

<style lang="stylus">
.image__spinner
  width 60px
  height 60px
  border-radius 40px
  border 1px solid white
  position absolute
  top 0
  left 0
  bottom 0
  right 0
  margin auto
  animation load2 2s infinite linear

@keyframes load2
  0%
    transform scale(0.2)
  50%
    transform scale(1)
  100%
    transform scale(0.2)

.image__wrapper
  overflow hidden
  position relative
  img
    min-width 100%
    min-height 100%
    display block
    position absolute
    top 0
    left 0
    bottom 0
    right 0
    margin auto
    opacity 0
    transition opacity 200ms linear
.loaded
  .image__spinner
    display none
  img
    opacity 1
</style>
